import { render, staticRenderFns } from "./SettingFormio.vue?vue&type=template&id=45afa3b2&scoped=true"
import script from "./SettingFormio.vue?vue&type=script&lang=js"
export * from "./SettingFormio.vue?vue&type=script&lang=js"
import style0 from "./SettingFormio.vue?vue&type=style&index=0&id=45afa3b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45afa3b2",
  null
  
)

export default component.exports